import { SVGProps } from "react";

export default function RightArrow(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={1.5}
      {...props}
    >
      <path
        d="M21.977 11.224 12.287 1M12.287 21.47 21.977 11.246M1.53 11.219 22 11.219"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
